// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ICoordinateSchema } from './CoordinateSchema';
import type { IMetroLineSchema } from '../metro/MetroLineSchema';

export interface IInfrastructureItemV4Schema {
  /** Адрес **/
  address?: string;
  /** Координаты пина на карте **/
  coordinates: ICoordinateSchema;
  /** Дистанция от ЖК **/
  distance: string;
  /** id **/
  id: string;
  /** Вид инфраструктуры **/
  kind?: EKind;
  /** Отображаемое название вида инфраструктуры **/
  kindName?: string;
  /** Линия метро **/
  line?: IMetroLineSchema;
  /** Время пешком до объекта **/
  timeWalk: number;
  /** Название объекта **/
  title: string;
  /** Тип объекта инфраструктуры **/
  type: EType;
  /** Отображаемое название типа инфраструктуры **/
  typeName?: string;
}

export enum EKind {
  /** Пляжи **/
  'Beaches' = 'beaches',
  /** МЦД **/
  'Mcd' = 'mcd',
  /** Метро **/
  'Metro' = 'metro',
  /** Парки **/
  'Parks' = 'parks',
}
export enum EType {
  /** Пляжи **/
  'Beaches' = 'beaches',
  /** Кафе **/
  'Cafe' = 'cafe',
  /** Поликлиники **/
  'Clinic' = 'clinic',
  /** Продуктовые магазины **/
  'Grocery' = 'grocery',
  /** Метро **/
  'Metro' = 'metro',
  /** Детские сады **/
  'Nursery' = 'nursery',
  /** Парки **/
  'Parks' = 'parks',
  /** Общий тип для парков и пляжей **/
  'RestAreas' = 'restAreas',
  /** Школы **/
  'School' = 'school',
}
